<div
  class="chat-message"
  [class.user]="message().role === 'user'"
  [class.assistant]="message().role === 'assistant'"
>
  <div class="message-content">
    @if (message().role === 'assistant') {
      @if (message().isStreaming && !message().content) {
        <div class="thinking">
          <span
            class="thinking-dots"
            aria-hidden="true"
          >
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      } @else {
        <markdown [data]="message().content"></markdown>
        @if (message().isStreaming) {
          <span class="streaming-cursor"></span>
        }
      }
    } @else {
      <p>{{ message().content }}</p>
    }
  </div>
  <div class="message-time">
    {{ message().timestamp | date: 'shortTime' }}
  </div>
</div>
